import { useEffect } from "react";

// Lightweight per-page SEO / document head control without an extra dependency.
export default function Seo({ title, description, noindex = false }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = `${title} · My Within`;

    const descEl = document.querySelector('meta[name="description"]');
    const prevDesc = descEl?.getAttribute("content");
    if (description && descEl) descEl.setAttribute("content", description);

    let robots = null;
    let robotsCreated = false;
    if (noindex) {
      robots = document.querySelector('meta[name="robots"]');
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
        robotsCreated = true;
      }
      robots.setAttribute("content", "noindex");
    }

    return () => {
      document.title = prevTitle;
      if (descEl && prevDesc != null) descEl.setAttribute("content", prevDesc);
      if (noindex && robots) {
        if (robotsCreated) robots.remove();
        else robots.setAttribute("content", "index");
      }
    };
  }, [title, description, noindex]);

  return null;
}
